module.exports = __webpack_public_path__ + "img/evaluated.7db3cb50.svg";